import { render } from "./RInput.vue?vue&type=template&id=82f32efe"
import script from "./RInput.vue?vue&type=script&lang=js"
export * from "./RInput.vue?vue&type=script&lang=js"

import "./RInput.vue?vue&type=style&index=0&id=82f32efe&lang=css"
script.render = render

export default script